import { apiClient } from "shared/api/client";

const API_URL = process.env.REACT_APP_API_URL;

// export const getLatestFacebookPosts = async ({
//   signal,
// } = {}) => {
//   return apiClient(
//     `${API_URL}/ti/api/social/facebook/latest/`,
//     { signal }
//   );
// };

export const getLatestFacebookPosts = async ({
  signal,
} = {}) => {
  const result = await apiClient(
    `${API_URL}/ti/api/social/facebook/latest/`,
    { signal }
  );
  return result;
};